import React from 'react';
import ReactDOM from 'react-dom';
import './reset.css';
import Home from './pages/Home';
import Video from './pages/cadastro/Video';
import Categoria from './pages/cadastro/Categoria';
import PageDefault from './components/PageDefault';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

const Pagina404 = () => (<PageDefault>Página 404</PageDefault>)


ReactDOM.render(
  <BrowserRouter>
    <Switch>
        <Route exact path='/' component={Home}/>
        <Route exact path='/cadastro/video'component={Video}/>
        <Route exact path='/cadastro/categoria'component={Categoria}/>
        <Route component={Pagina404} />
    </Switch>
    
  </BrowserRouter>,
  document.getElementById('root')
);